import { useEffect, useRef, useState } from 'react'
import TicketController, {
  IProductTicketsProp,
} from '../controllers/TicketController'
import { TProductTicketLogPagination } from '../types/Tickets'
import { IErrorResponse } from '../types/ErrorResponse'

const valueDefault = {
  items: [],
  page: 0,
  rowsPerPage: 0,
  totalPages: 0,
  total: 0,
}

export const useProductTicketLogs = ({
  productId,
  page,
  rows,
  search,
}: IProductTicketsProp) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<TProductTicketLogPagination>(valueDefault)
  const [error, setError] = useState<string>('')

  const executing = useRef(false)

  const execute = async () => {
    if (!loading && !executing.current) {
      executing.current = true
      try {
        setLoading(true)

        if (error !== '') {
          setError('')
        }

        const response = await TicketController.getLogs({
          productId,
          page,
          rows,
          search,
        })
        const responseError = response as IErrorResponse
        const responseData = response as TProductTicketLogPagination

        if (responseError.code) {
          setError(responseError.error)
          setData(valueDefault)
        } else {
          setData(responseData)
        }
      } catch (e) {
        var message = 'Erro não identificado'
        if (typeof e === 'string') {
          message = e.toUpperCase()
        } else if (e instanceof Error) {
          const err = e as Error
          message = err.message
        }
        setError(message)
      } finally {
        setLoading(false)
        executing.current = false
      }
    }
  }

  useEffect(() => {
    execute()
  }, [page, rows, search])

  const clear = () => {
    setError('')
  }

  return {
    loading,
    data,
    error,
    execute,
    clear,
  }
}
